module.exports = __webpack_public_path__ + "static/media/exit.9e4e2f0a.svg";